import type { Container, Newable } from "inversify";
import { Module } from "@designboticteam/core";
import { type IMapLibreCameraSyncService, MAPLIBRE_CAMERA_SYNC_SERVICE, MapToWorkspace3DCameraSyncService } from "./services/CameraSyncService";
import { ParcelShapeService } from "./services/ParcelShapeService";

type MapLibreConnectorModuleConfig = {
	cameraSyncService?: Newable<IMapLibreCameraSyncService>;
};

class MapLibreConnectorModule extends Module {
	public readonly moduleName = "🔗 MapLibreConnectorModule";

	private cameraSyncService!: IMapLibreCameraSyncService;
	protected services = [ParcelShapeService];

	constructor(private readonly config: MapLibreConnectorModuleConfig = {}) {
		super();
	}

	public register(container: Container): void {
		super.register(container);

		container
			.bind(MAPLIBRE_CAMERA_SYNC_SERVICE)
			.to(this.config.cameraSyncService ?? MapToWorkspace3DCameraSyncService)
			.inSingletonScope();
	}

	public initialize(): void {
		super.initialize();
		this.cameraSyncService = this.container.get(MAPLIBRE_CAMERA_SYNC_SERVICE);
		this.cameraSyncService.initialize();
	}

	public dispose(): void {
		this.cameraSyncService.dispose();
		super.dispose();
	}

	public get api() {
		return {
			maplibreConnector: {
				syncDirection: this.cameraSyncService.syncDirection,
			},
		};
	}
}

export { MapLibreConnectorModule, type MapLibreConnectorModuleConfig };
